import React from 'react';
import { useState, useRef } from 'react';
import axios from 'axios';

export function FilePreviewer({
	orgData,
	isMaxLimit = true,
	handleApiCall,
	buttonDisabled,
}) {
	const filePicekerRef = useRef(null);
	const [imagePreview, setImagePreview] = useState(null);
	const [videoPreview, setVideoPreview] = useState(null);

	const [isUploading, setIsUploading] = useState(null);

	function previewFile(e) {
		const reader = new FileReader();
		const selectedFile = e.target.files[0];
		if (selectedFile) {
			reader.readAsDataURL(selectedFile);
		}
		reader.onload = (readerEvent) => {
			if (selectedFile.type.includes('image')) {
				setImagePreview(readerEvent.target.result);
			} else if (selectedFile.type.includes('video')) {
				setVideoPreview(readerEvent.target.result);
			}
		};
	}
	function clearFiles() {
		setImagePreview(null);
		setVideoPreview(null);
	}

	async function handleUpload() {
		const upload_preset = 'pv9mlmap';
		const cloud_name = 'sponsor-circle';

		const formData = new FormData();

		let url = `https://api.cloudinary.com/v1_1/${cloud_name}/image/upload`;
		formData.append('upload_preset', upload_preset);

		if (videoPreview) {
			url = `https://api.cloudinary.com/v1_1/${cloud_name}/video/upload`;
			formData.append('file', videoPreview);
		} else {
			formData.append('file', imagePreview);
		}

		try {
			setIsUploading(true);
			const { data } = await axios.post(url, formData);
			await handleApiCall(orgData, data);
			clearFiles();
			setIsUploading(false);
			location.reload();
		} catch (error) {
			console.log(error);
		}
	}

	if (isUploading) {
		return <div>Loading...</div>;
	}

	return (
		<div>
			<div className="btn-container">
				{isMaxLimit && (
					<label
						className="attachinary optional"
						htmlFor="organization_images"
					>
						(up to 4, maximum file size 10MB)
					</label>
				)}
				<input
					ref={filePicekerRef}
					accept="image/*, video/*"
					onChange={previewFile}
					type="file"
					hidden
				/>
				<button
					disabled={imagePreview || videoPreview || buttonDisabled}
					className="fileupload-input-button"
					onClick={() => filePicekerRef.current.click()}
				>
					Choose
				</button>
			</div>

			{(videoPreview || imagePreview) && (
				<div>
					<h1>Preview</h1>
					<div className="preview">
						<button
							onClick={() => clearFiles()}
							className="cross-button"
						>
							x
						</button>
						{imagePreview != null && (
							<img src={imagePreview} alt="" />
						)}
						{videoPreview != null && (
							<video type="video/mp4" src={videoPreview}></video>
						)}
					</div>
					<div>
						<input
							type="button"
							onClick={() => handleUpload()}
							name="commit"
							value="Save"
							className="button"
						/>
					</div>
				</div>
			)}
		</div>
	);
}
